export enum KeyPrefix {
  schedule = 'schedule',
  timeOff = 'timeOff',
}

export interface DateRange {
  endDate: string;
  startDate: string;
}
